<p>
  Входът в профила ви осигурява достъп до всички основни и разширени функционалности на платформата – включително
  публикуване на обяви, участие в наддавания, изпращане на съобщения, управление на покупки и настройки на профила.
</p>
<h6 class="mt-3">Как да влезете в профила си?</h6>
<ol>
  <li>
    Натиснете бутона <strong>„Вход“</strong> или отворете директно страницата за
    <a class="text-decoration-none"
       [routerLink]="[appRoutes.root, appRoutes.account, appRoutes.login]">
      вход.
    </a>
  </li>
  <li>
    Въведете своя <strong>имейл адрес</strong> или <strong>потребителско име (никнейм)</strong>, използвани при
    регистрация.
  </li>
  <li>
    Въведете своята <strong>парола</strong>, като обърнете внимание на главни/малки букви, интервали и символи – те имат
    значение.
  </li>
  <li>
    Натиснете бутона <strong>„Вход“</strong>, за да влезете в профила си.
  </li>
</ol>
<h6 class="mt-3">Алтернатива: Вход чрез Google</h6>
<p>
  Ако сте регистрирали профила си чрез Gmail, може да използвате опцията <strong>„Вход с Google“</strong>. Ще бъдете
  пренасочени към страницата на Google, където да потвърдите самоличността си.
</p>
<p>
  При първоначален вход с Google, ако все още не сте задали парола, платформата ще ви подканва да го направите. Тази
  парола се използва при потвърждение на важни действия, като покупка, наддаване или промени по профила.
</p>
<h6 class="mt-3">Какво се случва след успешен вход?</h6>
<p>
  Ще бъдете автоматично пренасочени към началната страница. Профилът ви става активен, а вие получавате достъп до своя
  контролен панел, известия, съобщения и всички лични настройки.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Ако използвате споделено или обществено устройство, винаги излизайте от профила си след
  приключване на работа, за да защитите личната си информация.
</div>
